import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import TableComponent, { HeadCell, TableRowFeatures } from '../../../component/table/table.component';
import { Staff } from '../../../models'
import './scss/account-manager.style.scss';
import { groupUnitData } from '../group-unit';
import MultiTab from '../../../component/tab/multi-tab.component';
import { EditAccount, editAccountMobx } from './edit-account';
import ButtonComponent from '../../../component/button/button.component';
import i18n from 'i18next'
import DeleteDialog from '../../../component/dialog/delete-dialog.component';
import { useTranslation } from 'react-i18next';
import { PopoverEllipsis } from '../../../component/popover/popover-ellipsis';

const AccountManager = observer(() => {
    useTranslation();
    const [isOpenDetail, openDetail] = useState<boolean>(false);
    const [skeleton, setSkeleton] = useState<boolean>(false);
    const [editingInfo, edit] = useState<null | Staff>(null);

    useEffect(() => {
        groupUnitData.getStaffsData();
    }, []);

    const config = {
        route: [
            { title: i18n.t('ground_staff_component_text_associated_restaurant') },
            { title: i18n.t('ground_staff_component_text_unconnected_restaurants') },
        ]
    }
    const belongedArr =
        groupUnitData.belonged === '0' ? [false, true] :
            groupUnitData.belonged === '1' ? [true, false] :
                groupUnitData.belonged === '2' ? [true, true] :
                    [false, false];

    const tableHead: Array<HeadCell> = [
        {
            id: 'nickname', label: i18n.t('general_table_text_staff_name'), sortStatus: -1,
        },
        { id: 'email', label: i18n.t('general_text_email'), sortStatus: -1 },
        {
            id: 'phone', label: i18n.t('create_group_component_text_phone'), sortStatus: -1, renderFunction(row: Staff) {
                return `${row.phone_prefix || ''} ${row.phone || ''}`
            },
        },
        {
            id: '4', label: i18n.t('restaurant_info_page_table_text_associated_restaurant'), sortStatus: -1,
            renderFunction: (row) => {
                const bindRestaurantStr = row?.belonged_restaurant?.map((e: { nickname: string }) => e.nickname).join('，');
                return (
                    bindRestaurantStr.length > 30 ?
                        <>
                            <PopoverEllipsis showData={bindRestaurantStr} />
                        </>
                        :
                        <>{bindRestaurantStr}</>
                )
            }
        },
        {
            id: '5', label: '', sortStatus: -1,
            renderFunction: (row) => {
                return renderFeatures(row)
            }
        }
    ];

    const renderFeatures = (row: Staff): React.ReactNode => {
        return (
            <TableRowFeatures
                buttons={[
                    {
                        variant: 'contained',
                        color: 'secondary',
                        action: 'DELETE',
                        handleClick: () => {
                            groupUnitData.setDiglog({
                                open: true, message: [i18n.t('account_manager_confirm_delete')],
                                option: [
                                    [i18n.t('account_manager_yes'), async () => {
                                        await groupUnitData.deleteStaff(row);
                                        groupUnitData.setDiglog({ open: false })
                                    }],
                                    [i18n.t('general_button_cancel'), () => {
                                        groupUnitData.setDiglog({ open: false })
                                    }]
                                ],
                            })
                        }
                    },
                    {
                        variant: 'contained',
                        action: 'VIEW',
                        handleClick: async () => {
                            openDetail(true);
                            setSkeleton(true);
                            edit(row);
                            await editAccountMobx.getAccountInfo(row?._id);
                            setSkeleton(false);
                        }
                    }
                ]}
            />
        )
    };

    return (
        <div className='account-manager-panel-content'>
            <div className='topbar'>
                <ButtonComponent
                    {...{
                        variant: 'contained',
                        size: 'small',
                        extraButtonStyle: 'add-button',
                        titleText: i18n.t('set_meal_text_new'),
                        action: 'ADD',
                        handleClick: () => {
                            edit(null);
                            editAccountMobx.reset();
                            openDetail(true);
                        },
                    }}
                />
                <MultiTab
                    data={config.route}
                    activeIndexs={belongedArr}
                    containerStyle={{
                        flexDirection: 'row',
                        marginLeft: 4,
                    }}
                    itemStyle={{
                        marginLeft: 4,
                        marginRight: 4,
                        // width: 120,
                        height: 40,
                    }}
                    onClick={(activeIndexs: boolean[], i: number) => groupUnitData.updateBelonged(activeIndexs, i)}
                />
            </div>
            <div className='table-content'>
                <TableComponent
                    {...{
                        showChecked: 1,
                        list: groupUnitData.staffs ?? [],
                        headCellList: tableHead,
                        isTableLoading: groupUnitData.isTableLoading,
                        isPagination: true,
                        isUseFold: true,
                        allCount: groupUnitData.staffs.length,
                        extraClass: 'extraTable',
                        handleDeleteAll: async (rows: Staff[]) => {
                            await groupUnitData.deleteStaffs(rows);
                        },
                    }}
                />
            </div>
            <DeleteDialog
                open={groupUnitData.dialog.open}
                title={''}
                onCancel={() => {
                    groupUnitData.setDiglog({ open: false });
                }}
                onConfirm={async () => {
                    await groupUnitData?.dialog?.option?.[0]?.[1]();
                }}
            />
            <EditAccount
                skeleton={skeleton}
                editing={editingInfo}
                open={isOpenDetail}
                onClose={() => {
                    openDetail(false);
                    groupUnitData.getStaffsData();
                }}
            />
        </div>
    )
});

export default AccountManager;